import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';

import { AmazonMWSObjectDataset } from '../../model/dataset/amazon-mws.dataset';
import { Metamodel } from 'app/model/base/model';
import { AmazonMWSLinkedService } from '../../model/linkedservice/amazon-mws.linkedservice';
import { deprecatedConnectorDocLink } from 'app/shared/constants/links.const';

export const amazonMWSObjectMetadata: IDatasetTypeMetadata = {
    type: Metamodel.modelFor(AmazonMWSObjectDataset).name,
    displayName: stringResources.AmazonMWS_DisplayText,
    supportLinkedServiceTypes: [Metamodel.modelFor(AmazonMWSLinkedService).name],
    warningMessage: stringResources.Connector_Legacy_IsDeprecatedWarning,
    warningMessageHyperlink: deprecatedConnectorDocLink,
    isSource: true,
    isSink: false,
    datasetKind: 'table',
    icon: {
        className: 'svg-i-100x100-aws_marketplace'
    },
    isFirstClass: true,
    supportCreatedAsV2: true,
    notSupportPhysicalType: true,
    v1SupportSchema: true,
    category: ['ServicesApps']
};
